import { ENVIRONMENT_CONFIG, getValidEnvironment } from '@harbortouch/alexandria-utilities';

export const environmentConfig: () => {
	lhHost: string;
	steHost: string;
} = () => {
	const env = getValidEnvironment(process.env.NODE_ENV ?? '');
	return {
		lhHost: process.env.LH_API_HOST ?? ENVIRONMENT_CONFIG[env].lhApiHost,
		steHost: process.env.STE_API_HOST ?? ENVIRONMENT_CONFIG[env].steAPiHost,
	};
};
